/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionMatchParticipant
 */
export interface CompetitionMatchParticipant {
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchParticipant
     */
    participantId: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchParticipant
     */
    participantType: CompetitionMatchParticipantParticipantTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchParticipant
     */
    displayName: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionMatchParticipant
     */
    score?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionMatchParticipant
     */
    confirmedResult?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompetitionMatchParticipant
     */
    confirmedAt?: number;
}


/**
 * @export
 */
export const CompetitionMatchParticipantParticipantTypeEnum = {
    USER: 'USER',
    TEAM: 'TEAM'
} as const;
export type CompetitionMatchParticipantParticipantTypeEnum = typeof CompetitionMatchParticipantParticipantTypeEnum[keyof typeof CompetitionMatchParticipantParticipantTypeEnum];


/**
 * Check if a given object implements the CompetitionMatchParticipant interface.
 */
export function instanceOfCompetitionMatchParticipant(value: object): value is CompetitionMatchParticipant {
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('participantType' in value) || value['participantType'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function CompetitionMatchParticipantFromJSON(json: any): CompetitionMatchParticipant {
    return CompetitionMatchParticipantFromJSONTyped(json, false);
}

export function CompetitionMatchParticipantFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionMatchParticipant {
    if (json == null) {
        return json;
    }
    return {
        
        'participantId': json['participantId'],
        'participantType': json['participantType'],
        'displayName': json['displayName'],
        'score': json['score'] == null ? undefined : json['score'],
        'confirmedResult': json['confirmedResult'] == null ? undefined : json['confirmedResult'],
        'confirmedAt': json['confirmedAt'] == null ? undefined : json['confirmedAt'],
    };
}

export function CompetitionMatchParticipantToJSON(json: any): CompetitionMatchParticipant {
    return CompetitionMatchParticipantToJSONTyped(json, false);
}

export function CompetitionMatchParticipantToJSONTyped(value?: CompetitionMatchParticipant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participantId': value['participantId'],
        'participantType': value['participantType'],
        'displayName': value['displayName'],
        'score': value['score'],
        'confirmedResult': value['confirmedResult'],
        'confirmedAt': value['confirmedAt'],
    };
}

